jQuery( ".nhr-form .searchInputModal" ).focus(function() {
  jQuery(this).parent().parent().addClass("active");
});

jQuery( ".nhr-form .searchInputModal" ).focusout(function() {
  setTimeout(
    function () {
      jQuery(".nhr-form").removeClass("active");
    }, 250);
});